export const FEATURE_FLAGS_INTERNAL_STATE = '__FEATURE_FLAGS_STATE__'
export const EXPERIMENT_PARTICIPATE_EVENT_NAME = 'Experiment.Participate'

// Upper bound on network calls made during SSR setup (GrowthBook init and
// the viewer-profile Apollo query). Both must cap latency so a slow upstream
// can't block page rendering — on timeout, callers fall back to declared
// defaults / cookie attrs.
export const NETWORK_TIMEOUT_MS = 1000
